import { getActivities, getClaims, getNotes, getTasks } from '@maia/shared';
import { http, HttpResponse } from 'msw';

function baseResponse<T>(response: T, page = 1, limit = 10) {
  return {
    statusCode: 200,
    response,
    success: true,
    error: null,
    pagination: {
      page_number: page,
      page_size: limit,
      total_results: 110,
      total_pages: 11,
    },
  };
}

export const handlers = [
  http.get('http://localhost:3000/claims', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const customers = getClaims(limit);
    return HttpResponse.json(baseResponse(customers));
  }),
  http.get('http://localhost:3000/claims/:guid/activities', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const page = parseInt(url.searchParams.get('page') ?? '1');
    const activities = getActivities(limit);
    return HttpResponse.json(baseResponse(activities, page, limit));
  }),
  http.get('http://localhost:3000/claims/:guid/notes', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const page = parseInt(url.searchParams.get('page') ?? '1');
    const notes = getNotes(limit);
    return HttpResponse.json(baseResponse(notes, page, limit));
  }),
  http.get('http://localhost:3000/claims/:guid/tasks', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const page = parseInt(url.searchParams.get('page') ?? '1');
    const tasks = getTasks(limit);
    return HttpResponse.json(baseResponse(tasks, page, limit));
  }),
];
